import type { FormatOptions } from "./format.types";

export const formatArray = (options: FormatOptions): string => {
  const castArray = (
    Array.isArray(options.value) ? options.value : [options.value]
  ).map((v) => String(v));
  return options.style === "short"
    ? `[${castArray.join(", ")}]`
    : String(options.value);
};
